module.exports = __webpack_public_path__ + "img/hoslogo20.1b674225.png";